/*=========================================================================================
  File Name: moduleScheduleActions.js
  Description: Schedule Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";

export default {
	removeRoutingDone({commit}, {key, upload_file_id}) {
		return new Promise((resolve, reject) => {
			Api.delete(`/routingdone/${key}/${upload_file_id}`)
				.then((response) => {
					// Modificamos en el store la informacion de los ruteos realizados para este upload file id removiendo el actual
					commit("DELETE_ROUTING_DONE", {upload_file_id, key});
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	getRoutingDone({commit}, id) {
		return new Promise((resolve, reject) => {
			Api.get("/routingdone/" + id + "/0")
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};
